import { AxiosResponse } from 'axios';
import { HTTP } from '@/utils';
import {
  PersonBuildingInterface,
  OrganizationBuildingInterface,
  PersonBuildingRequest,
  OrganizationBuildingRequest,
} from '@/types/BuildingInterface';

export default class BuildingService {
  static resource_person = 'person';
  static resource_building = 'building';
  static resource_buildings = 'buildings';
  static resource_organizations = 'organization';

  private static personBuildingsUrl(id: number) {
    return `${this.resource_person}/${id}/${this.resource_buildings}`;
  }

  private static organizationBuildingsUrl(id: number) {
    return `${this.resource_organizations}/${id}/${this.resource_buildings}`;
  }

  private static extractData<T>(response: AxiosResponse<{ data: T }>): T {
    return response.data.data;
  }

  static async getPersonBuildings(person_id: number): Promise<PersonBuildingInterface[]> {
    const response = await HTTP.get(this.personBuildingsUrl(person_id));
    return this.extractData<PersonBuildingInterface[]>(response);
  }

  static async getOrganizationBuildings(organization_id: number): Promise<OrganizationBuildingInterface[]> {
    const response = await HTTP.get(this.organizationBuildingsUrl(organization_id));
    return this.extractData<OrganizationBuildingInterface[]>(response);
  }

  static async attachPersonBuilding(payload: PersonBuildingRequest, person_id: number): Promise<PersonBuildingRequest> {
    const response = await HTTP.post(`${this.personBuildingsUrl(person_id)}/attach`, payload);
    return this.extractData<PersonBuildingRequest>(response);
  }

  static async detachPersonBuilding(payload: PersonBuildingRequest, person_id: number): Promise<PersonBuildingRequest> {
    const response = await HTTP.post(`${this.personBuildingsUrl(person_id)}/detach`, payload);
    return this.extractData<PersonBuildingRequest>(response);
  }

  static async deleteOrganizationBuilding(building_id: number): Promise<void> {
    await HTTP.delete(`${this.resource_building}/${building_id}`);
  }

  static async createOrganizationBuilding(
    payload: OrganizationBuildingRequest,
  ): Promise<OrganizationBuildingInterface> {
    const response = await HTTP.post(this.resource_buildings, payload);
    return this.extractData<OrganizationBuildingInterface>(response);
  }

  static async updateOrganizationBuilding(
    payload: OrganizationBuildingRequest,
    building_id: number,
  ): Promise<OrganizationBuildingInterface> {
    const response = await HTTP.patch(`${this.resource_building}/${building_id}`, payload);
    return this.extractData<OrganizationBuildingInterface>(response);
  }
}
